module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('text-input', {
    attrs: {
      "label": _vm.label,
      "prop": _vm.prop,
      "required": _vm.required,
      "type": "number",
      "decimals": _vm.decimals,
      "pattern": _vm.pattern,
      "size": _vm.size,
      "align-input": "right",
      "min": _vm.min,
      "max": _vm.max,
      "prefix": _vm.prefix,
      "suffix": _vm.suffix,
      "is-prefix-icon": _vm.isPrefixIcon,
      "is-suffix-icon": _vm.isSuffixIcon,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "no-form": _vm.noForm
    },
    on: {
      "input": function($event) {
        _vm.v = parseFloat($event)
      },
      "change": _vm.updated
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559b4a02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/FloatInput.vue
// module id = 1494
// module chunks = 0